import React from 'react';

export const data = {
  title: "Let’s Talk Money",
  rows: [
    {
      index: 0,
      title: <b>Do I have to pay per copy? </b>,
      content: "Not a chance. You pay per employee (with a monthly subscription) or per pay stub (with pay stub packs). Once a pay stub is finalized, you can download it as many times as you want."
    },
    {
      index: 1,
      title: <b>Is there a minimum amount of paystubs I need to buy at a time? </b>,
      content: "No, but the price per pay stub goes down as you buy more. (Hint: buy more.)",
    },
    {
      index: 2,
      title: <b>What is the difference between one-time and membership options? </b>,
      content: "One-time purchases (single pay stubs or pay as you go) give you pay stub credits. Pay stub credits can be used to finalize pay stubs for any employee at any time. They don’t expire. We also sell monthly or annual subscriptions that allow you to generate pay stubs for the number of employees corresponding to your subscription amount. e.g. If you have a monthly subscription for 3 employees, you can generate as many pay stubs as you need for each of those employees."
    },
    {
      index: 3,
      title: <b>Do you do refunds? </b>,
      content: "You bet. If you are unhappy with our service for any reason, we are happy to provide a refund. We just ask that you give us feedback so we can do better next time! If you need to cancel an unused subscription, we will provide up to three month’s refund on request. Get in touch if you’re unsatisfied with your services to discuss your options. "
    },   
  ]
};
